"use client";

import React from "react";
import { ArrowRight, ShoppingCart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToUpgrade() {
  return <section data-section-id="142562" id="secure-your-engine" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32 border-y-[12px] border-primary">
      {}
      <div className="absolute inset-0 bg-[image:linear-gradient(to_right,var(--color-primary)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-primary)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_80%_50%_at_50%_50%,#000_40%,transparent_100%)] opacity-10" aria-hidden="true" />
      
      {}
      <div className="absolute left-1/2 top-1/2 -z-10 h-[30rem] w-[30rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/20 blur-[120px]" aria-hidden="true" />

      <div className="relative z-10 mx-auto max-w-4xl px-6 text-center lg:px-8">
        <h2 className="text-4xl font-serif font-black tracking-tighter sm:text-6xl mb-6 uppercase text-foreground">
          Transition to System Ownership
        </h2>
        
        <p className="mx-auto max-w-2xl text-lg font-sans leading-8 text-muted-foreground mb-10">
          Stop being a "Call Taker" and start being a "System Owner." Secure your revenue pipeline with the industry's most robust AI operational infrastructure. Protect your legacy with 21st-century engineering.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="w-full sm:w-auto h-14 px-10 text-lg font-serif font-bold rounded-none shadow-2xl bg-primary text-primary-foreground hover:bg-primary/90">
            <Link to="/OperationalAuditPage">
              <ShoppingCart className="mr-2 size-5" />
              Begin Operational Audit
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-14 px-10 text-lg font-serif font-bold rounded-none bg-background/50 backdrop-blur-md border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300">
            <Link to="/TheEnginePage">
              Explore The Engine
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}